/* eslint-disable react/prop-types */
import React from 'react';

import RawButon from './styled-components';

const Button = ({ label, onClick, type, disabled, name, primary }) => (
  <RawButon onClick={onClick} type={type} disabled={disabled} name={name} primary={primary}>
    {label}
  </RawButon>
);

Button.defaultProps = {
  type: 'button',
  disabled: false,
  primary: false
};

export default Button;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/Button/index.js